module.exports = __webpack_public_path__ + "img/4.85dcfb53.jpg";